export default __webpack_public_path__ + "media/vendors/app_store_download-9a61f621.svg";